var React = require('react');

function WhitebgTop (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M188.002 2352C837.489 2352 1364 1825.49 1364 1176C1364 526.513 837.489 0 188.002 0C-461.485 0 -988 526.513 -988 1176C-988 1825.49 -461.485 2352 188.002 2352Z","fill":"url(#paint0_linear_5686_1397)","key":0}),React.createElement("defs",{"key":1},React.createElement("linearGradient",{"id":"paint0_linear_5686_1397","x1":"188","y1":"0","x2":"188","y2":"2352","gradientUnits":"userSpaceOnUse"},[React.createElement("stop",{"stopColor":"white","key":0}),React.createElement("stop",{"offset":"0.078125","stopColor":"#F7F6F3","key":1}),React.createElement("stop",{"offset":"0.911458","stopColor":"#F7F6F3","key":2}),React.createElement("stop",{"offset":"0.989583","stopColor":"white","key":3})]))]);
}

WhitebgTop.defaultProps = {"width":"1920","height":"143","viewBox":"0 0 375 143","fill":"none"};

module.exports = WhitebgTop;

WhitebgTop.default = WhitebgTop;
